"use client";
import {
  createDisclosureStore
} from "./L5RYKTVQ.js";

// src/dialog/dialog-store.ts
function createDialogStore(props = {}) {
  return createDisclosureStore(props);
}

export {
  createDialogStore
};
